import { useAppContext } from "../context/appContext";
import { useEffect } from "react";
import Loading from "./Loading";
import InformationItem from "./InformationItem";
import Wrapper from "../assets/wrappers/JobsContainer"
import { PageBtnContainer } from "./";
import { Link } from "react-router-dom";
import { BsPlusCircle } from 'react-icons/bs'
import calculations from "../utils/calculations";

const InformationItemContainer = () => {
    const {
        getInformationItems,
        informationItems,
        isLoading,
        totalInformationItems,
        search,
        sort,
        yearToDisplay, } = useAppContext();

    useEffect(() => {
        getInformationItems();
    }, [
        yearToDisplay,
        search,
        sort
    ]);

    if (isLoading) {
        return <Loading center />
    }

    return (
        <Wrapper>
            <div className="header">
                {Object.keys(informationItems).length === 0 ? <h5>Keine Einträge gefunden...</h5> :
                    <h5>{totalInformationItems} {totalInformationItems > 1 ? "Einträge" : "Eintrag"} gefunden</h5>
                }
                <Link to="/add-informationItem" type="button" className="btn"><BsPlusCircle />Eintrag hinzufügen</Link>
            </div>

            {Object.keys(informationItems).length === 0 ? <></> : <PageBtnContainer />}
            <div className="jobs">
                {Object.keys(informationItems).map((year, index) => {
                    year = parseInt(year)
                    if (year === yearToDisplay) {
                        var informationItemsToDisplay = calculations.filterItemsOfYear(informationItems, year)

                        if (sort === 'DESC') {
                            informationItemsToDisplay.reverse()
                        }

                        return informationItemsToDisplay.map((item, idx) => {
                            if (item.year === yearToDisplay) {
                                return <InformationItem
                                    key={informationItemsToDisplay[idx].id}
                                    currentInformationItem={informationItemsToDisplay[idx]}
                                    // Previous Information Item is the month before the current month
                                    // In DESC mode index + 1 and in ASC mode index - 1
                                    previousInformationItem={informationItemsToDisplay[(sort === 'DESC') ? idx + 1 : idx - 1]} />
                            }
                        })
                    }
                })}
            </div>
            {Object.keys(informationItems).length === 0 ? <></> : <PageBtnContainer />}
        </Wrapper>
    )
}

export default InformationItemContainer;